var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilePlusIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.396632,
    height: 16.0965,
    viewBox: "0 0 17.17 21.462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 { fill: #ffb103; }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file_pause",
    transform: "translate(-519.67 -443.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "reject",
    transform: "translate(486 419.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    d: "M45.536 24.036h-9.049a2.82 2.82 0 0 0-2.817 2.817v15.828a2.82 2.82 0 0 0 2.817 2.819h11.536a2.82 2.82 0 0 0 2.817-2.817V29.964zm.371 2.428l2.761 3.085h-2.761zm2.116 17.692H36.487a1.476 1.476 0 0 1-1.475-1.475V26.853a1.476 1.476 0 0 1 1.475-1.475h8.077v5.513H49.5v11.79a1.476 1.476 0 0 1-1.477 1.475z",
    className: "cls-1",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun_pause_button_3548679",
    transform: "translate(504.701 433.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1182",
    d: "M0 0H1.72V5.16H0z",
    className: "cls-1",
    transform: "translate(21 20.209)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1183",
    d: "M0 0H1.72V5.16H0z",
    className: "cls-1",
    transform: "translate(24.44 20.209)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePlusIcon);
export default __webpack_public_path__ + "static/media/FilePlusIcon.ed9bc24cfe56c9f536a5414729befae7.svg";
export { ForwardRef as ReactComponent };